import React from "react";
import { useMatches } from "react-router-dom";

import { faCommentDots, faCommentsAlt } from "@fortawesome/pro-solid-svg-icons";

// components
import { Tooltip } from "@performyard/py-components";

import IconButton from "../../components/Button/IconButton";
import { useFeedbackDrawerStore, useRequestFeedbackDrawerStore } from "./FeedbackDrawerStore";

//api
import { useCompanyFunction } from "../../api/hooks";
import { useFeatureFlagQuery } from "../../hooks/useFeatureFlag";

import { isInIframe } from "../../utils/isInIframe";

//utils
import RouterTags from "../../constants/RouterTags";
import css from "./FeedbackDrawers.module.scss";
import FeedbackDrawer from "./drawers/FeedbackDrawer";
import FeedbackRequestPanel from "./drawers/FeedbackRequestDrawer";

const FeedbackDrawers = () => {
	const { leaveFeedback } = useFeedbackDrawerStore();
	const { requestFeedback } = useRequestFeedbackDrawerStore();
	const { companyFunction: isFeedbackEnabled, attributes } = useCompanyFunction("feedback");
	const { value: feedbackFeatureVisible } = useFeatureFlagQuery("ff-is-feedback-enabled", true);

	// this is used to hide the cello launcher if the user is on a page that is not allowed to see them
	const matches = useMatches();
	let tags: string[] = [];
	if (matches.length > 0 && matches[matches.length - 1]?.handle) {
		const lastMatch = matches[matches.length - 1].handle as { tags: string[] };
		tags = lastMatch["tags"] || [];
	}

	const shouldShowFeedback = !tags.includes(RouterTags.NO_FEEDBACK);
	const shouldShowFeedbackRequest = attributes?.allowRequestFeedback;

	if (isInIframe()) {
		return null;
	}

	return (
		<section className="fixed bottom-[24px] right-[24px] z-[150]">
			{shouldShowFeedback && isFeedbackEnabled === "enabled" && feedbackFeatureVisible && (
				<div className={`${css.actionButtonsContainer} hide-in-pdf`}>
					{shouldShowFeedbackRequest && (
						<div className={` ${css.requestButton}`}>
							<Tooltip
								offset={-4}
								placement="left"
								content="Request Feedback"
								dangerouslySetClassName="z-[150]"
								asChild
							>
								<div>
									<IconButton
										testId="request-feedback-button"
										color="blue"
										onClick={() => requestFeedback()}
										className={`bg-blue-5 rounded-md p-2 text-white ${css.feedbackIconButton}`}
										icon={faCommentsAlt}
										size="large"
									/>
								</div>
							</Tooltip>
							<FeedbackRequestPanel />
						</div>
					)}
					<Tooltip
						offset={-4}
						placement="left"
						content="Give Employee Feedback"
						dangerouslySetClassName="z-[150]"
						asChild
					>
						<div>
							<IconButton
								testId="leave-feedback-button"
								color="blue"
								onClick={() => leaveFeedback()}
								className={`bg-blue-5 rounded-md p-2 text-white ${css.feedbackButton} ${css.feedbackIconButton}`}
								icon={faCommentDots}
								size="large"
							/>
						</div>
					</Tooltip>
					<FeedbackDrawer />
				</div>
			)}
		</section>
	);
};

export default FeedbackDrawers;
